import { useTranslate } from 'react-polyglot';

import { Button } from '@genially/design-system';
import { ShareIcon } from '@genially/icons';

import { useCopySessionLink } from '../../../../../../../../../../shared/application/hooks/useCopySessionLink';

export const ShareLinkAction = () => {
  const t = useTranslate();

  const { handleCopySessionClick } = useCopySessionLink('game');

  return (
    <Button
      variant={Button.Variant.STROKE_REVERSED}
      size={Button.Size.MEDIUM}
      width="100%"
      StartIcon={<ShareIcon />}
      onClick={handleCopySessionClick}
    >
      {t('__new.action.share')}
    </Button>
  );
};
